export enum ProfessionSubclass {
    Blacksmithing = 0,
    Leatherworking = 1,
    Alchemy = 2,
    Herbalism = 3,
    Cooking = 4,
    Mining = 5,
    Tailoring = 6,
    Engineering = 7,
    Enchanting = 8,
    Fishing = 9,
    Skinning = 10,
    Jewelcrafting = 11,
    Inscription = 12,
    Archaeology = 13,
}
